import { Vector3 } from 'three';
import { Label } from './Label.js';
export class DraggableLabel extends Label {
    onAfterRestore() {
        this.updatePosition();
    }
    constructor(name, viewType, objToAnchor, anchor = new Vector3(), params = {}, scaleFactor = 1, isDraggable = true) {
        super(name, viewType, objToAnchor, anchor, params, scaleFactor);
        this.ignoreReset = false;
        if (isDraggable) {
            this.interceptedByRaycaster = true;
            this.isDraggable = true;
            this.bindEvent('onDragMove', (args) => {
                if (this._objToAnchor) {
                    this.anchor.copy(args.position).sub(this._objToAnchor.position);
                }
                else {
                    this.anchor.copy(args.position);
                }
            });
        }
    }
    resetPosition() {
        if (!this.ignoreReset) {
            super.resetPosition();
        }
    }
}
//# sourceMappingURL=DraggableLabel.js.map